'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isParentOfActiveElement;
function isParentOfActiveElement(parent) {
  var node = document.activeElement;

  while (node && node.nodeName !== 'BODY') {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}